import * as Yup from 'yup';

import { password } from 'client/schemas/password.schema';

export const validationSchema = Yup.object().shape({
  password,
});
